import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

function themeColors() {
  const dark = window.matchMedia('(prefers-color-scheme: dark)').matches
  return {
    background: dark ? '#1f1f1f' : '#ffffff',
    // Capacitor 4: Dark = texto claro (fondos oscuros); Light = texto oscuro.
    style: dark ? Style.Dark : Style.Light,
  }
}

async function applyStatusBarTheme() {
  const { background, style } = themeColors()
  await StatusBar.setBackgroundColor({ color: background })
  await StatusBar.setStyle({ style })
}

/** En la app Android el WebView no debe pintarse debajo de la barra de estado. */
export async function configureNativeStatusBar(): Promise<void> {
  if (Capacitor.getPlatform() !== 'android') {
    return
  }
  try {
    await StatusBar.setOverlaysWebView({ overlay: false })
    await applyStatusBarTheme()
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      void applyStatusBarTheme()
    })
  } catch {
    // Web o plugin no disponible en este runtime.
  }
}
